//core
import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core";
//dashboard-pro
// import Button from "components/CustomButtons/Button.jsx";
//components
import ReactTable from "react-table";
// import Base64 from 'base-64';
// import { FilePond, registerPlugin } from "react-filepond";
// import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import PerfectScrollbar from "perfect-scrollbar";
//bussiness
import { GRID_CELL_WIDTH } from "global/config";
import UploadOss from "global/UploadOss";
//css
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const formStyle = makeStyles(regularFormsStyle);

// eslint-disable-next-line no-unused-vars
let ps;
function CompanyCertificationsTable(props) {
  const classes = formStyle();
  // const filepondClasses = filepondStyle();
  const uploadSuccess = (row, url) => {
    props.uploadSuccess(props.index, row, url); //这里的index是cartoryInfos的index
  };

  const deleteImg = (row, url) => {
    props.uploadSuccess(props.index, row, url, true);
  };

  const handleFileList = (infos) => {
    let resultArr = [];
    if (infos && infos.length > 0) {
      infos.forEach((el) => {
        if (el.attachurl) {
          resultArr.push(el.attachurl);
        }
      });
      return resultArr;
    }
    return "";
  };

  useEffect(() => {
    ps = new PerfectScrollbar("#certificationContainer", {
      suppressScrollX: true,
      suppressScrollY: false,
    });
  }, []);

  const tableColumns = [
    {
      Header: "证书名称",
      accessor: "name",
      sortable: false,
      maxWidth: GRID_CELL_WIDTH.veryLong,
      Cell: (prop) => (
        <span>
          {prop.original.required === 1 ? (
            <span className={classes.validationSymbol}>*</span>
          ) : (
            ""
          )}
          {prop.value}
        </span>
      ),
    },
    {
      Header: "证书上传",
      accessor: "upload",
      sortable: false,
      Cell: (prop) => (
        <UploadOss
          btnClassName=""
          type={prop.value + "certification"}
          deleteImg={(url) => deleteImg(prop.original, url)}
          fileList={handleFileList(prop.original.infos)}
          openSnackbar={props.openSnackbar}
          closeSnackbar={props.closeSnackbar}
          uploadSuccess={(url) => uploadSuccess(prop.original, url)}
        />
      ),
    },
    // {Header:'已上传',accessor:'infos',sortable:false,
    //     Cell:prop => (
    //         <span>
    //             {(prop.value && prop.value.length > 0) ? prop.value.map((k,key) => {
    //                 return (
    //                     k.attachurl ?
    //                     <span key={key} style={{display:'inline-block',marginRight:'5px'}}>
    //                         <div>
    //                             <a href={('http://v2cs-oss.oss-cn-beijing.aliyuncs.com/' + k.attachurl)} target="_blank" rel="noopener noreferrer">
    //                                 <img height='120' src={('http://v2cs-oss.oss-cn-beijing.aliyuncs.com/' + k.attachurl)} alt='...'/>
    //                             </a>
    //                         </div>
    //                         <div style={{textAlign:'center'}}>
    //                             <Button size="sm" onClick={() => deleteImg(prop.original,k,key)}>删除</Button>
    //                         </div>
    //                     </span> : ''
    //                 )
    //             }) : ''}
    //         </span>
    //         )
    // },
  ];

  return (
    <React.Fragment>
      <div
        className={classes.certificationContainer}
        id="certificationContainer"
      >
        <ReactTable
          data={props.tableData}
          columns={tableColumns}
          defaultPageSize={props.tableData.length}
          className="-striped -highlight"
        />
      </div>
    </React.Fragment>
  );
}

export default CompanyCertificationsTable;
//以下部分为上传控件
// registerPlugin(FilePondPluginImageExifOrientation);

// let uploadFileName;
// let uploadFileAllName;

// const getName = fileName => {
//     let date = new Date();
//     let month = date.getMonth() + 1;
//     month = month > 9 ? month : '0' + month;
//     let dir = date.getFullYear() + '/' + month + '/' + date.getDate() + '/';

//     let s = [];
//     let hexDigits = "0123456789abcdef";
//     for (let i = 0; i < 32; i++) {
//         s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
//     }
//     s[12] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
//     s[16] = hexDigits.substr((s[16] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
//     let uuid = s.join("");

//     let pos = fileName.lastIndexOf('.')
//     let suffix = ''
//     if (pos !== -1) {
//         suffix = fileName.substring(pos)
//     }

//     uploadFileName=(uuid + suffix);
//     uploadFileAllName=(dir + uuid + suffix);
// }

// function CertificateFilePond(props){
//     const policyText = {
//         "expiration": "2020-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
//         "conditions": [
//             ["content-length-range", 0, 1048576000] // 设置上传文件的大小限制
//         ]
//     };

//     return (
//         <FilePond id="cerificationFile" files={[]} maxFiles={props.maxFiles}
//             allowDrop={true}
//             allowMultiple={true}
//             server={{
//                 url:"http://v2cs-oss.oss-cn-beijing.aliyuncs.com",
//                 process:(fieldName, file, metadata, load, error, progress, abort) => {
//                     const formData = new FormData();
//                     getName(file.name);
//                     // console.log(this.state.uploadFileAllName);
//                     formData.append('name', uploadFileName);
//                     formData.append('key', uploadFileAllName);
//                     formData.append('policy', Base64.encode(JSON.stringify(policyText)));
//                     formData.append('OSSAccessKeyId', 'LTAI5tGhsE2FSb5zo597CRmb');
//                     formData.append('success_action_status', '200');
//                     formData.append('signature', 'uwKDasWp/zq6Ik4MLpoWsXDKpSg=');
//                     formData.append('file', file, uploadFileName);
//                     const request = new XMLHttpRequest();
//                     request.open('POST', 'http://v2cs-oss.oss-cn-beijing.aliyuncs.com');

//                     request.upload.onprogress = (e) => {
//                         progress(e.lengthComputable, e.loaded, e.total);
//                     };
//                     let that = props;
//                     request.onload = function() {
//                         if (request.status >= 200 && request.status < 300) {
//                             let url = request.responseURL + uploadFileAllName;
//                             console.log(url);
//                             load(url);
//                             that.uploadSuccess(that.row,uploadFileAllName);
//                         }else {
//                             // Can call the error method if something is wrong, should exit after
//                             error('出错了');
//                         }
//                     };

//                     request.send(formData);
//                     return {NODE_PATH=./src
//                         abort: () => {
//                                 // This function is entered if the user has tapped the cancel button
//                                 request.abort();
//                                 // Let FilePond know the request has been cancelled
//                                 abort();
//                         }
//                     };
//                 },
//                 load:{url:'http://v2cs-oss.oss-cn-beijing.aliyuncs.com'},
//                 revert:null,
//                 fetch:null,
//                 restore:null
//             }}
//             onprocessfile={(err,file) => {//上传完成，存一波链接
//                 // console.log(file.serverId);
//             }}
//             onremovefile={(err,file) => {
//                 if (!err) {//找一下，将点击之后的那个
//                     console.log(file.file);
//                 }
//             }}
//             onactivatefile={fileItem => {
//                 const link = document.createElement('a');
//                 link.target = '_blank';
//                 let href = fileItem.source;
//                 link.href = href;
//                 link.download = true;
//                 document.body.appendChild(link);
//                 link.click();
//                 document.body.removeChild(link);
//             }}
//             labelIdle='<span class="filepond--label-action">点击上传</span>'
//             labelFileProcessingComplete='上传成功'
//             labelFileProcessing='上传中'
//             labelFileLoadError='出错了'
//             labelFileProcessingError='出错了'
//             labelFileLoading='载入中'
//             labelFileProcessingAborted='上传取消'
//             labelTapToCancel='点击取消'
//             labelTapToRetry	='点击重试'
//             labelTapToUndo	='点击删除'
//             labelButtonRemoveItem	='删除'
//             labelButtonProcessItem	='上传'
//             labelButtonAbortItemLoad	='放弃'
//             labelButtonRetryItemLoad	='重试'
//             labelButtonRetryItemProcessing	='重试'
//             labelButtonAbortItemProcessing	='取消'/>
//     )
// }
